import React from "react"
import { getProductIcon } from "./getProductIcon"
import { ProductType } from "../types.d"

interface ProductImagePlaceholderProps {
  productType: ProductType
}

export const ProductImagePlaceholder = ({
  productType,
}: ProductImagePlaceholderProps) => {
  const ProductIcon = getProductIcon(productType)

  return (
    <div className="bg-brand-300 grid aspect-square w-full max-w-lg flex-col place-items-center">
      <ProductIcon className="text-brand-500 h-1/2 w-1/2" />
    </div>
  )
}
